import useDate from "@/services/utils/day";

// Route Categories
const BVA_REPORT_ROUTES = ['project-bva', 'donor-report-bva'];

const CONTACT_AND_SPEC_ROUTES = [
  'specification-list', 'business-list', 'contacts-all', 'contacts-employee', 
  'contacts-supplier', 'contacts-customer', 'contacts-member', 'add-contact', 
  'contact-profile', 'work-status-update', 'contacts-create'
];

const DAILY_REPORT_ROUTES = [
  'day-book', 'pharmacy-bill-list', 'opd-billing-list', 'hospital-bill-list', 
  'investigation-bill-list', 'prescription-psc', 'daily-cash-summary', 
  'sales-report-general', 'user-sales-summary', 'pending-sample-laboratory', 
  'single-service', 'ipd-station', 'ipd-register', 'prescription-doctor', 
  'money-receipt-statements', 'user-collection-summary', 'bill-manager', 
  'pharmacy-billing', 'my-visit-schedule', 'visit-plan-list', 
  'opd-billing-report', 'supershop-pos-list'
];

const PRODUCTWISE_REPORT_ROUTES = ['sales-report-productwise', 'ipd-sales-collection-report'];

export const getPageRouterPayload = (page, context) => {
  const { companyId, moduleId, menuId } = context;
  const date = useDate();
  
  const basicParams = {
    companyId,
    moduleId,
    menuId,
    pageId: page.id,
  };

  const getFirstDate = (interval = 0) => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth() - interval, 2).toISOString().split('T')[0];
  };

  const getLastDate = () => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth() + 1, 1).toISOString().split('T')[0];
  };

  if (page.route === 'accounts-list') {
    return { name: page.route, params: { ...basicParams, accountType: 'asset' } };
  }

  if (page.route === 'business-location') {
    return { name: page.route, params: { ...basicParams, accountType: 'fg_warehouse' } };
  }

  if (page.route === 'inventory-list') {
    return { name: page.route, params: { ...basicParams, accountType: 'finished_goods' } };
  }

  if (page.route === 'service-resources') {
    return { name: page.route, params: { ...basicParams, accountType: 'human_resources' } };
  }

  if (page.route === 'chart-of-accounts-ngoab') {
    return { name: page.route, params: { ...basicParams, accountType: 'expense' } };
  }

  if (CONTACT_AND_SPEC_ROUTES.includes(page.route)) {
    return { name: page.route, params: basicParams };
  }

  if (page.route === 'contact-register') {
    return { name: page.route, params: basicParams, query: { page: 1 } };
  }

  if (page.route === 'company-settings') {
    return { name: page.route, params: { companyId, moduleId } };
  }

  if (BVA_REPORT_ROUTES.includes(page.route)) {
    return {
      name: page.route,
      params: basicParams,
      query: { 
        start: getFirstDate(3),
        end: getLastDate()
      }
    };
  }

  if (page.route === 'profit-loss-analytics') {
    return {
      name: page.route,
      params: basicParams,
      query: { 
        start: getFirstDate(5),
        end: getLastDate()
      }
    };
  }

  if (DAILY_REPORT_ROUTES.includes(page.route)) {
    return {
      name: page.route,
      params: basicParams,
      query: { start: date.currentDate(), end: date.currentDate(), page: 1 }
    };
  }

  if (PRODUCTWISE_REPORT_ROUTES.includes(page.route)) {
    return {
      name: page.route,
      params: basicParams,
      query: { date: date.currentDate() }
    };
  }

  return {
    name: page.route,
    params: { ...basicParams, accountType: 'asset' },
    query: {
      start: getFirstDate(),
      end: getLastDate(),
      page: 1
    }
  };
};
